import { useIsMobile } from "@nimble/react-state-hooks/use-mobile";

import MultiSelectView, {
  MultiSelectViewProps,
} from "@/components/shared/multi-select/multi-select.view";
import { CommandEmpty } from "@/components/ui/command";

export interface MultiSelectProps<T = string | number>
  extends Omit<MultiSelectViewProps<T>, "onChange" | "isMobile"> {
  onChange: (value: T[]) => void;
}

export default function MultiSelect<T = string | number>({
  value = [],
  onChange,
  title,
  options,
  groups,
  ListItem,
  GroupItem,
  isMultiSelect = true,
  itemLabel,
  ...props
}: MultiSelectProps<T> & { itemLabel?: string }) {
  const isMobile = useIsMobile();

  const handleSelect = (selectedValue: T) => {
    const currentValues = value || [];
    const isSelected = currentValues.includes(selectedValue);

    if (isSelected) {
      onChange(currentValues.filter((v) => v !== selectedValue));
    } else {
      onChange([...currentValues, selectedValue]);
    }
  };

  return (
    <MultiSelectView
      title={title}
      options={options}
      groups={groups}
      onChange={handleSelect}
      isMobile={isMobile}
      value={value}
      ListItem={ListItem}
      GroupItem={GroupItem}
      isMultiSelect={isMultiSelect}
      itemLabel={itemLabel}
      {...props}
    >
      <CommandEmpty>No options found</CommandEmpty>
      {props.children}
    </MultiSelectView>
  );
}
